/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum IncidentSubtype {
    APP = 'APP',
    AUTO_CALL = 'AUTO_CALL',
    CALLER_ID_SPOOF = 'CALLER_ID_SPOOF',
    CALL_FROM_SUSPECTED_SUBSCRIBER = 'CALL_FROM_SUSPECTED_SUBSCRIBER',
    CASINO = 'CASINO',
    CASINO_CEPI = 'CASINO_CEPI',
    CF = 'CF',
    CYBER_SEC = 'CYBER_SEC',
    D = 'D',
    DRUG = 'DRUG',
    DRUG_CEPI = 'DRUG_CEPI',
    FB = 'FB',
    FC = 'FC',
    FE = 'FE',
    FI = 'FI',
    FL = 'FL',
    FM = 'FM',
    FMB = 'FMB',
    FS = 'FS',
    FTS = 'FTS',
    MF_OTHER = 'MF_OTHER',
    PD = 'PD',
    PYRAMID = 'PYRAMID',
    PYRAMID_CEPI = 'PYRAMID_CEPI',
    Q = 'Q',
    REM_CALL = 'REM_CALL',
    SIM_BOX = 'SIM_BOX',
    SN = 'SN',
    SOC_ENGINEERING = 'SOC_ENGINEERING',
    TRANSFER_DISCLOSURE = 'TRANSFER_DISCLOSURE',
    UNCHARACTER = 'UNCHARACTER'
}

